import { Tooltip, Typography } from '@analytical-alley/ui';
import { IconExclamationCircle } from '@tabler/icons-react';
import React from 'react';

export const GradientLegend = ({
    title,
    tooltip,
    minValue,
    maxValue,
    gradient,
}: {
    title?: string;
    tooltip?: string;
    minValue: string | number;
    maxValue: string | number;
    gradient: { minColor: string; maxColor: string };
}) => {
    return (
        <div className="flex flex-col align-center text-center">
            <div className="flex gap-1 items-center align-middle mb-1">
                {title ? (
                    <Typography variant="bodyXS" tooltip={tooltip}>
                        {title}
                    </Typography>
                ) : null}
            </div>
            <div
                style={{
                    backgroundImage: `linear-gradient(to right, ${gradient?.minColor}, ${gradient?.maxColor})`,
                }}
                className={'h-5 rounded-2xl'}
            ></div>
            <div className="flex justify-between mt-1 dark:text-white text-dark">
                <div className="text-xs -translate-x-2">{minValue}</div>
                <div className="text-xs translate-x-2">{maxValue}</div>
            </div>
        </div>
    );
};
